import { render, staticRenderFns } from "./eventWelcome.vue?vue&type=template&id=27e86622&scoped=true"
import script from "./eventWelcome.vue?vue&type=script&lang=js"
export * from "./eventWelcome.vue?vue&type=script&lang=js"
import style0 from "./eventWelcome.vue?vue&type=style&index=0&id=27e86622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e86622",
  null
  
)

export default component.exports